import { DefaultAddress } from '../../clients/urls';

const SERVER_ADDRESS_KEY = 'smart_translate_server_address';

export function saveServerAddress(address: string) {
  localStorage.setItem(SERVER_ADDRESS_KEY, address);
}

export function loadServerAddress(): string {
  return localStorage.getItem(SERVER_ADDRESS_KEY) || DefaultAddress;
}

export function clearServerAddress() {
  localStorage.removeItem(SERVER_ADDRESS_KEY);
}
